import { get } from 'lodash';

export default class OpencellAPI {

	constructor(host, auth, providerCode) {
		this.host = host;
		this.providerCode = providerCode;

		let authorization = null;
		if(auth && auth.token) {
			authorization = "Bearer " + auth.token;
		} else {
			const credentials = [api_user.username, api_user.password].join(":");
			authorization = "Basic " + btoa(credentials);
		}

		this.requestOptions = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Credentials': true,
				'Access-Control-Allow-Methods': 'DELETE, GET, OPTIONS, POST, PUT',
				'Access-Control-Allow-Headers': 'x-requested-with, Content-Type, origin, authorization, accept, client-security-token',
				'Access-Control-Max-Age': '1000',
				'Authorization': authorization
			},
			mode: 'cors',
			cache: 'no-cache'
		};
	}

	invokeRequest(payload, url, method) {
		this.requestOptions.body = JSON.stringify(payload);
		return this.callApi(url, false, method);
	}


	buildDirectUrl({url}) {
		return this.host + url;
	}

	callApi(url = "/", isFile = false, method = "GET") {
		this.requestOptions.method = method;
		const fullUrl = this.host + url;
		return new Promise((resolve, reject) => {
			fetch(fullUrl, this.requestOptions)
				.then(checkStatus)
				.then((data) => {
				  if(isFile){
				    return data.text();
				  } else {
				    return parseJson(data);
				  }
				})
				.then(data => {
					resolve(data);
				})
				.catch(error => {
					reject(error);
				});
		});
	}

	createCustomEntity(entity) {
		const url = "/api/rest/customEntityInstance/";
		return this.invokeRequest(entity, url, "POST");
	}

	createCRMAccountHierarchy(entity) {
		const url = "/api/rest/account/accountHierarchy/createCRMAccountHierarchy";
		return this.invokeRequest(entity, url, "POST");
	}

	updateCRMAccountHierarchy(entity) {
		const url = "/api/rest/account/accountHierarchy/updateCRMAccountHierarchy";
			return this.invokeRequest(entity, url, "POST");
	}

	updateUser(customer) {
		const url = "/api/rest/user/external";
		return this.invokeRequest(customer, url, "PUT");
	}

	forgotPassword(email) {
		const url = "/inbound/" + this.providerCode + "/forgotPassword";
		this.invokeRequest({email}, url, "POST");
	}

	resetPassword(password) {
		const url = "/api/rest/account/resetPassword/";
		return this.invokeRequest({password}, url, "POST");
	}

  find_user(customerCode) {
    const url = "/api/rest/v2/generic/all/userAccount";
    return this.invokeRequest({
      filters: {
        "billingAccount.customerAccount.customer.code": customerCode
      },
      nestedEntities: [
		"billingAccount.customerAccount.customer.customerAccounts.paymentMethods.customerAccount"
      ]
    }, url, "POST")
      .then(response => {
        const customer = get(response, "data[0].billingAccount.customerAccount.customer", null);

		return {
          actionStatus: {
            status: customer ? 'SUCCESS' : 'FAIL'
          },
          customers: {
            customer: [customer]
		  }  
        };
      });
  }

	find_customer(customerCode) {
		const url = "/api/rest/v2/generic/all/customer";
		return this.invokeRequest({
			filters: {
				"code": customerCode
			},
			nestedEntities: [
				"customerAccounts.paymentMethods.customerAccount"
			]
		}, url, "POST")
			.then(response => {
				const customer = get(response, "data[0]", null);

				return {
					actionStatus: {
						status: customer ? 'SUCCESS' : 'FAIL'
					},
					customers: {
						customer: [customer]
					}
				};
			});
	}

	contact(contactData) {
		const url = "/api/rest/account/contact/";
		return this.invokeRequest(contactData, url, "POST");
	}

}

function parseJson(data) {
	if (!!data) {
		return data.text().then((text = {}) => {
			return !!text && JSON.parse(text);
		});
	}
	return null;
}

function checkStatus(response) {
	if (response.status >= 200 && response.status < 300) {
		return response
	} else {
		const error = new Error(response.statusText);
		error.response = response;
		throw error
	}
}



// WEBPACK FOOTER //
// ./src/opencell/OpencellAPI.js